/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2023.

!Changelog

2023
	10-03-2023
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_loader = {};

(function(){

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	this.loading = function(
		_start
	) {

		if(_start == 1) {

			/*
			Logo: Icon Loading
			*/
			$('.js-logo').find('.icon').removeClass('paused');

			is_loading_animation = 1;

		} else {

			/*
			Logo: Icon Loading
			*/
			$('.js-logo').find('.icon').addClass('paused');

			is_loading_animation = 0;

		}

	};

	this.notifier = function(
		_start,
		_error,
		_message
	) {

		/*
		Notifier: Show
		*/
		specific_interactions.notifier(1,_error,_message);

	};
			
}).apply(specific_loader); 